import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Layout, Menu, Space, Button, Dropdown, Avatar, message } from 'antd';
import { Content, Header } from 'antd/es/layout/layout';
import Sider from 'antd/es/layout/Sider';
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import '@/styles/components/defaultLayout.scss';
import { getPath } from '@/scripts/utils';
import LAYOUT_MENU from '@/router/menu';
import { PATH_ORDER_LIST, PATH_LOGIN } from '@/router/path';
import { COOKIE_TOKEN } from '@/scripts/config';
import Cookies from 'js-cookie';
import ajax from '@/scripts/ajax';
// console.log(LAYOUT_MENU, 'LAYOUT_MENU');
export default function DefaultLayout() {
    // hooks
    const { pathname } = useLocation();
    const navigate = useNavigate();
    // state
    const [collapsed, setCollapsed] = useState(false); // 菜单项是否折叠
    const [activeMenuKeys, setActiveMenuKeys] = useState(null); // 当前激活的菜单项
    // store
    // const { data: userInfo } = useGetUserInfoQuery();

    useEffect(() => {
        window.addEventListener('resize', handleWindowResize);
        getActiveMenuKeys();
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, [pathname]);

    // 获取无层级结构的路径数组
    const getPaths = (data = LAYOUT_MENU, flatData = []) => {
        data.forEach((parent) => {
            const { label, key, children } = parent;
            flatData.push({ label, key });
            if (children) getPaths(children, flatData);
        });
        return flatData;
    };

    // 获取当前菜单高亮项
    const getActiveMenuKeys = () => {
        const flatData = getPaths();
        flatData.forEach(({ key }) => {
            if (key && pathname.indexOf(key) > -1) setActiveMenuKeys(key);
        });
    };

    // 窗口变化回调
    const handleWindowResize = () => {
        if (!collapsed && window.innerWidth <= 800) setCollapsed(true);
    };

    // 处理导航菜单点击
    const handleMenuSelect = (ev) => {
        const path = ev?.key;
        if (!!path) navigate(path);
    };

    // 处理登出回调
    const handleLogout = () => {
        // ajax.post('/Login/Logout').then(() => {
        //     Cookies.remove(COOKIE_TOKEN);
        //     Cookies.remove(COOKIE_USERID);
        //     window.location.hash = getPath([PATH_LOGIN], null, true);
        // });
        // window.location.hash = getPath([PATH_LOGIN], null, true);
        // ajax.get('/auth/logout').then((response) => {
        //     message.success(response);
        //     Cookies.remove(COOKIE_TOKEN);
        //     // Cookies.remove(COOKIE_USERID);
        //     navigate('/login');
        // });
        Cookies.remove(COOKIE_TOKEN);
        localStorage.removeItem('refresh_token');
        navigate('/login');
    };

    // 用户菜单
    const userInfoMenu = [{ key: 'logout', label: <span onClick={handleLogout}>用户登出</span> }];

    return (
        <Layout hasSider style={{ minHeight: '100%' }}>
            <div className="ax-default-layout__sider-placeholder" style={{ width: collapsed ? 48 : 220 }}></div>
            <Sider width="220" className="ax-default-layout__sider" theme="light" collapsed={collapsed} collapsedWidth={48}>
                <div className="ax-default-layout__sider-content">
                    <Menu
                        mode="inline"
                        items={LAYOUT_MENU}
                        onSelect={handleMenuSelect}
                        selectedKeys={activeMenuKeys}
                        defaultOpenKeys={[getPath([PATH_ORDER_LIST])]}
                    />
                </div>
            </Sider>
            <Layout className="ax-default-layout__main">
                <Header />
                <Header className="ax-default-layout__header">
                    <div className="ax-default-layout__header-left">
                        <div className="ax-default-layout__header-logo">
                            <h1>Spacem</h1>
                        </div>
                        <Button
                            type="text"
                            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                            onClick={() => setCollapsed(!collapsed)}
                            style={{ color: '#ffffff' }}
                        ></Button>
                    </div>
                    <Space>
                        {/*<Divider className="ax-default-layout__header-divider" type="vertical" />*/}
                        {/* <div className="ax-default-layout__userInfo"> */}
                        {/*{userInfo ? (*/}
                        {/*    <Dropdown menu={{ items: userInfoMenu }} placement="bottomRight" arrow>*/}
                        {/*        <Space>*/}
                        {/*            <span className="ax-default-layout__userInfo-name">{userInfo?.UserName}</span>*/}
                        {/*            <Avatar style={{ backgroundColor: '#1677ff' }} size="40">*/}
                        {/*                {userInfo?.UserName.substring(0, 1)}*/}
                        {/*            </Avatar>*/}
                        {/*        </Space>*/}
                        {/*    </Dropdown>*/}
                        {/*) : null}*/}
                        {/* </div> */}

                        {/* 退出登录 */}
                        {/* <div className="ax-default-layout__userInfo">
                            <Dropdown menu={{ items: userInfoMenu }} placement="bottomRight" arrow>
                                <Space style={{ marginBottom: '10px' }}>
                                    <span className="ax-default-layout__userInfo-name"></span>
                                    <Avatar style={{ backgroundColor: '#1677ff' }} size="40">
                                        A
                                    </Avatar>
                                </Space>
                            </Dropdown>
                        </div> */}
                        <Button type="primary" danger onClick={handleLogout}>
                            登出
                        </Button>
                    </Space>
                </Header>
                <Content className="ax-default-layout__content">
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
}
